import { createSlice } from "@reduxjs/toolkit";

export const modelSlice = createSlice({
    name: 'model',
    initialState: {
        type: null,
        data: null
    },
    reducers: {
        setModel: (state, {payload: {type, data}}) => {
            state.type = type;
            if (data)
                state.data = data
        },
        resetModel: (state, props) => {
            state.type = null;
            state.data = null;
        }
    }
})

export const { setModel, resetModel } = modelSlice.actions;
export default modelSlice.reducer;
